import { featureCards } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            为什么选择樱花漫画
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            我们用心打磨每一个功能细节，只为给你最好的漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureCards.map((item, idx) => (
            <div
              key={item.title}
              className="group p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/60 text-center hover:border-primary-200 transition-colors duration-200"
            >
              <div
                className={`w-12 h-12 mx-auto flex items-center justify-center rounded-xl mb-4 ${
                  idx === 0
                    ? 'bg-primary-100 text-primary-600'
                    : idx === 1
                    ? 'bg-accent-100 text-accent-600'
                    : idx === 2
                    ? 'bg-secondary-100 text-secondary-600'
                    : idx === 3
                    ? 'bg-primary-100 text-primary-600'
                    : 'bg-accent-100 text-accent-600'
                }`}
              >
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}